import M1 from "./M1.png";
import M2 from "./M2.png";
import M3 from "./M3.png";
import M4 from "./M4.png";



const MEMBERSIMG = [M1, M2, M3, M4];

export default MEMBERSIMG;